import { NotFoundPage } from '@pages/NotFound/NotFoundPage';
import { AppUrlEnum } from '@enums/app.enum';
import React from 'react';
import {
  createBrowserRouter,
  RouterProvider as ReactRouterProvider,
} from 'react-router-dom';
import { ErrorBoundaryLayout } from '@components/Layout/ErrorBoundaryLayout';
import { RootLayout } from '@components/Layout/RootLayout';
import { HomeLayout } from '@components/Layout/HomeLayout';
import { LegalLayout } from '@components/Layout/LegalLayout';
import { CoverageLayout } from '@components/Layout/CoverageLayout';
import { ArWithdrawalCancellationPage } from '@pages/ArWithdrawalCancellation/ArWithdrawalCancellationPage';
import { ArFeesPage } from '@pages/ArFees/ArFeesPage';

const router = createBrowserRouter([
  {
    children: [
      {
        element: <HomeLayout />,
        index: true,
      },
      {
        element: <LegalLayout />,
        path: AppUrlEnum.Legal,
      },
      {
        element: <CoverageLayout />,
        path: AppUrlEnum.CoverageDetail,
      },
      {
        element: <ArFeesPage />,
        path: AppUrlEnum.ArFees,
      },
      {
        element: <ArWithdrawalCancellationPage />,
        path: AppUrlEnum.ArWithdrawalCancellation,
      },
    ],
    element: <RootLayout />,
    errorElement: <ErrorBoundaryLayout />,
    path: '/',
  },
  {
    element: <NotFoundPage />,
    path: '*',
  },
]);

export const RouterProvider = () => <ReactRouterProvider router={router} />;
